import './App.css';
import AppRoutes from "./AppRoutes";
import Header from './components/Header';
import Footer from './components/Footer';


function App() {
  return (
    <>
      <Header></Header>
      <AppRoutes />
      <Footer></Footer>
    </>
  );
}

export default App;
